import React, { Component } from 'react';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../../Services/translation';
import QuickSearchNavigation from './QuickSearchNavigation';

class QuickSearch extends Component {
  focusOnInput() {
    setTimeout(() => {
      this.searchInput && this.searchInput.focus();
    }, 0);
  }

  render() {
    const {
      query,
      result,
      showResult,
      showFullForm,
      onSearch,
      onBlur,
      onKeyDown,
      toggleShowFullForm,
      selectedItem,
      searchUrl,
      dataCase,
      dataMenus,
    } = this.props;

    const isCaseOne = dataCase == 'case-one' ? true : false; // inhouse-group
    const isCaseTwo = dataCase == 'case-two' ? true : false; // matt-tema

    if (dataCase)
      return (
        <div className="quick-search" role="search">
          <button
            className="quick-search__link--block"
            aria-label={translate('general.search')}
            onClick={(e) => {
              toggleShowFullForm();
              this.focusOnInput();
            }}
          >
            <i className="ph-magnifying-glass"></i>
            <span className="[ quick-search__title ] [ text-small text-large-from-medium lh-2 color-grey-900 ]">
              {translate('general.search')}
            </span>
          </button>
          <div
            className={`quick-search__form ${
              showFullForm ? 'quick-search__form--force-show' : ''
            }`}
            role="search"
          >
            <div className="quick-search__input--wrapper row">
              <div className="columns small-12">
                <input
                  className="quick-search__input"
                  type="text"
                  placeholder={translate('quicksearch.search-placeholder')}
                  autoComplete="off"
                  value={decodeURIComponent(query)}
                  onChange={(event) =>
                    onSearch(encodeURIComponent(event.target.value))
                  }
                  onClick={
                    isCaseTwo && !showFullForm
                      ? (e) => toggleShowFullForm()
                      : null
                  }
                  onKeyDown={(event) => onKeyDown(event, { searchUrl })}
                  ref={(input) => {
                    this.searchInput = input;
                  }}
                  onBlur={() => onBlur()}
                />
                <i
                  className="fal fa-times"
                  onClick={(e) => {
                    onSearch('');
                    toggleShowFullForm();
                  }}
                ></i>
              </div>
            </div>
            {showResult ? (
              <QuickSearchResult
                result={result}
                selectedItem={selectedItem}
                searchUrl={searchUrl}
                showResult={showResult}
                dataMenus={dataMenus}
              />
            ) : (
              showFullForm && (
                <QuickSearchNavigation noSearch={true} isCaseOne={isCaseOne} dataMenus={dataMenus}/>
              )
            )}
          </div>
        </div>
      );
  }
}

export default QuickSearch;
